var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('HeaderCom'),_vm._v(" "),_c('Contact'),_vm._v(" "),_c('div',{attrs:{"id":"body"}},[_c('router-view',{key:_vm.key})],1),_vm._v(" "),_c('MakeAppointment'),_vm._v(" "),_c('FooterCom')],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-0cd65a1b","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/layout.vue
// module id = null
// module chunks = 